import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Projections for Limited Concepts",
description: "Learn how to display limited concepts in Freon using radio groups for single-valued properties and checkbox lists for multi-valued properties.",
tags: [ "limited concepts", "projections", "radio group", "checkbox list", "enumeration", "editor controls", "projectional editor", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:12:52.262Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};